export default "__VITE_ASSET__LzoIARbS__"